import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Settings01 } from "@untitledui/icons";
import type { ActionType } from "@/types/workflow";
import { useTranslation } from "react-i18next";

export const ActionNode = ({ data }: NodeProps) => {
    const { t } = useTranslation('pages:workflows-admin');
    const actionType = (data?.action_type as ActionType | undefined);
    const dataLabel = (data?.label as string) || "";

    const actionTypeLabels: Record<ActionType, string> = {
        notification_in_app: t('workflows.editor.actionTypes.notification_in_app'),
        notification_email: t('workflows.editor.actionTypes.notification_email'),
        notification_both: t('workflows.editor.actionTypes.notification_both'),
    };

    const label = actionType ? actionTypeLabels[actionType] : dataLabel || t('workflows.editor.defaultLabels.action');

    return (
        <div className="rounded-lg bg-utility-warning-100 border-2 border-utility-warning-600 shadow-md min-w-[150px]">
            <Handle type="target" position={Position.Top} className="w-3 h-3 bg-utility-warning-600" />
            <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-utility-warning-600" />
            <div className="flex flex-col gap-1 px-3 py-2">
                <div className="flex items-center gap-2">
                    <Settings01 className="size-4 text-utility-warning-700" />
                    <span className="text-sm font-semibold text-utility-warning-800">{label}</span>
                </div>
                {actionType && (
                    <span className="text-xs text-utility-warning-700 opacity-75">{actionType}</span>
                )}
            </div>
        </div>
    );
};
